import React, {createContext} from "react";

export const ResumeInstanceContext = createContext();
export const ModuleContext = createContext();
export const FieldContext = createContext();
export const ModuleContentContext = createContext();
